'use client'

import Script from 'next/script'

import { configPublic } from '@src/config.public'
import { useLocale } from '@src/i18n/LocaleProvider'

export function LoudCrowd() {
  const { t } = useLocale('common')
  const shoppingWithText = t('shopping-with')

  function initLoudCrowd() {
    // Initialize LoudCrowd
    window.loudcrowd.init(configPublic.loudCrowd.shopId)

    // Gather elements
    const hero = document
      .querySelector('ambassador-hero-block')
      ?.shadowRoot?.querySelector('loudcrowd-hero')
    const shoppingWith = hero?.shadowRoot?.querySelector('.bio-description>span')
    const feed = document
      .querySelector('ambassador-feed-block')
      ?.shadowRoot?.querySelector('loudcrowd-multi-collection')
    const navbar = feed?.shadowRoot?.querySelector('loudcrowd-navbar')
    const feedInfinite = feed?.shadowRoot?.querySelector('loudcrowd-infinite-feed')
    const grid = feedInfinite?.shadowRoot?.querySelector('loudcrowd-masonry-grid')

    // Get existing exportparts attribute values
    const heroExports = hero?.getAttribute('exportparts')
    const feedExports = feed?.getAttribute('exportparts')
    const navbarExports = navbar?.getAttribute('exportparts')

    // Set child parts
    hero?.shadowRoot?.querySelector('.bio-wrapper')?.setAttribute('part', 'bio-wrapper')
    hero?.shadowRoot?.querySelector('h1')?.setAttribute('part', 'bio-name')
    shoppingWith?.setAttribute('part', 'shopping-with')
    hero?.shadowRoot?.querySelector('.hero-wrapper')?.setAttribute('part', 'hero-wrapper')
    grid?.setAttribute('part', 'grid')
    navbar?.shadowRoot?.querySelector('.active-tile')?.setAttribute('part', 'active-tile')

    // Export child parts
    hero?.setAttribute(
      'exportparts',
      `${heroExports},bio-wrapper,hero-wrapper,shopping-with,bio-name`
    )
    feed?.setAttribute('exportparts', `${feedExports},grid,active-tile`)
    feedInfinite?.setAttribute('exportparts', `grid`)
    navbar?.setAttribute('exportparts', `${navbarExports},active-tile`)

    // Manipulate DOM
    if (shoppingWith) shoppingWith.textContent = shoppingWithText
  }
  return (
    <Script
      type="module"
      crossOrigin="anonymous"
      strategy="afterInteractive"
      onLoad={initLoudCrowd}
      src={configPublic.loudCrowd.scriptUrl}
    />
  )
}
